module.exports = __webpack_public_path__ + "img/2.23f96e47.svg";